module.exports = __webpack_public_path__ + "media/button.85c8bdda.wav";